
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col } from "react-bootstrap";
import { ComparisonContext } from "../../../../config/context/comparisonContext";
import { useContext } from "react";




const CompareFeatures = () => {

    const { compareDetails, setCompareDetails } = useContext(ComparisonContext);

    const carData = compareDetails.first || compareDetails.second || compareDetails.third || compareDetails.fourth
    const featureList = carData?.features
    const firstCarFeatures = compareDetails?.first?.features
    const secondCarFeatures = compareDetails?.second?.features
    const thirdCarFeatures = compareDetails?.third?.features
    const fourthCarFeatures = compareDetails?.fourth?.features


    return (
        <div className="App">
             
                {featureList && Object.keys(featureList).map((feature: any, index:number) => (
                    <Row className="border-bottom px-0" key={index}>
                        <Col md={2} className=" comparsion-img-out text-start border-end">
                            <p className="text-start mt-2">{featureList[feature].name}</p>
                        </Col>
                        <Col md={2} className="comparsion-img-out text-start border-end">
                            <p className="text-start   mt-2"> 
                            {firstCarFeatures?.[feature].value || '-'}
                            </p>
                        </Col>
                        <Col md={2} className="comparsion-img-out text-start border-end">
                            <p className="text-start   mt-2"> 
                            {secondCarFeatures?.[feature].value || '-'}
                            </p>
                        </Col>
                        <Col md={2} className="comparsion-img-out text-start border-end">
                            <p className="text-start   mt-2"> 
                            {thirdCarFeatures?.[feature].value || '-'}
                            </p>
                        </Col>
                        <Col md={2} className="comparsion-img-out text-start">
                            <p className="text-start  mt-2"> 
                            {fourthCarFeatures?.[feature].value || '-'}
                            </p>
                        </Col>
                    </Row>
                ))}
        </div >
    );
};

export default CompareFeatures;
